import React from 'react';

import Banner from '@/components/Base/Banner';
import PageBreadcrumbs from '@/components/Base/PageBreadcrumbs';
import NotFoundPage from '@/components/Pages/NotFoundPage';
import Actions from '@/components/Pages/Product/Actions';
import { Details } from '@/components/Pages/Product/Details/Details';
import MainInfo from '@/components/Pages/Product/MainInfo';
import MainInfoLoader from '@/components/Pages/Product/MainInfoLoader';
import ProductAttributesNav from '@/components/Pages/Product/ProductAttributesNav';
import { BANNERS } from '@/constants';
import {
  useBusinessConditionsFields,
  useGetProductBiId,
  usePageProps,
} from '@/hooks';
import { getRateDisplay } from '@/utils';

import { BreadcrumbsWrapper, LayoutStyles } from './Product.styles';

function Product() {
  const pageProps = usePageProps();
  const { params, intl } = pageProps;
  const { locale, formatMessage } = intl;
  const { productData, isFetching } = useGetProductBiId({
    locale,
    params,
  });
  const rateDisplay = getRateDisplay({
    ...productData,
    formatMessage,
  });

  const { fields, navs } = useBusinessConditionsFields(
    productData ? { ...productData, rateDisplay } : {}
  );

  if (
    (!productData ||
      productData?.companySlug !== params.companySlug ||
      productData?.productId?.toString() !== params.productId ||
      productData?.slug !== params.skuSlug) &&
    !isFetching
  )
    return <NotFoundPage />;

  return (
    <LayoutStyles dataTestId="product-page">
      {isFetching ? (
        <MainInfoLoader />
      ) : (
        <MainInfo {...productData} rateDisplay={rateDisplay} />
      )}

      {!!productData?.actions?.length && (
        <Actions actions={productData.actions} />
      )}

      {navs && <ProductAttributesNav navs={navs} canBeMoved />}

      {fields && <Details fields={fields} />}

      <BreadcrumbsWrapper>
        <Banner {...BANNERS.catfish} />

        <PageBreadcrumbs />
      </BreadcrumbsWrapper>
    </LayoutStyles>
  );
}

export default Product;
